module.exports = "/shared/img/header-fast.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/header-fast.png
// module id = 25
// module chunks = 13